import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import logoDarkMode from "../assets/img/brand/logo-dark-mode.png";
import logoLightMode from "../assets/img/brand/logo-light-mode.png";

/**
 * Logo component - displays the appropriate brand logo based on the current theme
 * @param {string} className - CSS class name (optional)
 * @param {object} style - Inline styles (optional)
 * @param {string} alt - Alt text for the image (optional, defaults to "Brand Icon")
 * @param {object} sx - Additional props to spread on the img element (optional)
 */
export const Logo = ({
  className = "",
  style = {},
  alt = "Brand Icon",
  ...props
}) => {
  const theme = useTheme();
  const logo = theme.palette.mode === "dark" ? logoDarkMode : logoLightMode;

  return (
    <img src={logo} className={className} style={style} alt={alt} {...props} />
  );
};

Logo.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  alt: PropTypes.string,
};
